import React from "react";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixConfirmationProps } from "../types";

const PixConfirmation: React.FC<PixConfirmationProps> = ({ amount }) => {
  const classes = usePixModalStyles();

  const formatted = amount.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div className={classes.confirmationBox}>
      <div className={classes.confirmInfo}>
        <div className={classes.confirmIcon}>
          <CheckCircleIcon style={{ fontSize: 20 }} />
        </div>
        <div>
          <div className={classes.confirmTitle}>Pagamento confirmado</div>
          <div className={classes.confirmText}>
            Pedido liberado para entrega
          </div>
        </div>
      </div>
      <div className={classes.confirmAmount}>R$ {formatted}</div>
    </div>
  );
};

export default PixConfirmation;
